import TreeFullViewPage from "pages/TreeFullViewPage";
import React from "react";

const TreeFullViewRoute = () => <TreeFullViewPage />;

export default TreeFullViewRoute;
